import { AuthenticationProvider } from '@microsoft/microsoft-graph-client';
import { IPublicClientApplication, InteractionRequiredAuthError } from '@azure/msal-browser';

export class GraphAuthenticationProvider implements AuthenticationProvider {
  private readonly scope: string;
  private msalInstance: IPublicClientApplication;

  public constructor(scope: string, msalInstance: IPublicClientApplication) {
    this.scope = scope;
    this.msalInstance = msalInstance;
  }

  public async getAccessToken(): Promise<string> {
    const activeAccount = this.msalInstance.getActiveAccount();
    const accounts = this.msalInstance.getAllAccounts();

    if (!activeAccount && accounts.length === 0) {
      await this.msalInstance.loginRedirect();
      return '';
    }

    try {
      const tokenResponse = await this.msalInstance.acquireTokenSilent({
        scopes: [this.scope],
        account: activeAccount || accounts[0],
      });
      return tokenResponse.accessToken;
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
        await this.msalInstance.acquireTokenRedirect({ scopes: [this.scope] });
        return '';
      }
      throw error;
    }
  }
}
